import { FetchBaseQueryError } from '@reduxjs/toolkit/query'

// Legacy's $http default.
export const legacyAccept = { Accept: 'application/json, text/plain, */*' }

// With the browser's default `Accept: */*` the apiserver answers some writes with 500 without CORS headers, even after storing them.
export const jsonAnswer = { Accept: 'application/json' }

// `null` for an empty body.
export const optionalJson = async (response: Response) => {
  const text = await response.text()
  return text ? JSON.parse(text) : null
}

// `null` for an empty body, and the text itself when it isn't JSON.
export const optionalJsonOrText = async (response: Response) => {
  const text = await response.text()
  if (!text) return null
  try {
    return JSON.parse(text)
  } catch {
    return text
  }
}

export const customError = (error: string): FetchBaseQueryError => ({ status: 'CUSTOM_ERROR', error })
